export default __webpack_public_path__ + "static/media/38.c724ee7f.jpg";